/* eslint-disable localRules/console-error-deprecated */
import bugsnagClient from '@getaccept/lib-shared/src/bugsnag';

export const logger = {
  /**
   * @description
   * Logs message/error to console and bugsnag.
   *
   * Takes same arguments as console.error
   */
  error: (message?: any, ...optionalParams: any[]) => {
    if (message?.name !== 'ApolloError') {
      bugsnagClient?.notify(message);
    }
    console.error(message, ...optionalParams);
  },
} as const;
